import { personAddressFrag } from '../../../../../services/types/person.types';

export const getMissingRecordsFrag = `
    id
    date
    folderId
    folder {
        id
        personId
        serviceId
        serviceInfo {
            name
            color
        }
        status
        createdAt
        person {
            id
            createdAt
            image
            birthdate
            titleBeforeName
            titleAfterName
            name
            surname
            alias
            sex
            email
            addresses {
                ${personAddressFrag}
            }
        }
        activeGroups {
            group {
                name
            }
        }
        anamnesis {
            id
            dateFrom
            createdAt
            updatedAt
            dateTo
            doctor {
                id
                name
                surname
                titleBeforeName
                titleAfterName
                email
                icpOfDoctor
            }
        }
        workplaces {
            id
            workplaceId
            name
            dateFrom
            dateTo
        }
    }
`;
